module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.28580",
      "ably": "static-2.2",
      "data-fetching-client": "static-1.9549",
      "ably-hubspot-js": "static-2.4584",
      "atom": "static-1.4943",
      "conversations-async-data": "static-2.7537",
      "conversations-error-reporting": "static-1.8750",
      "conversations-internal-pub-sub": "static-1.15838",
      "conversations-internal-schema": "static-1.12618",
      "conversations-message-history": "static-1.12251",
      "conversations-test-sdk": "static-1.10372",
      "conversations-visitor-experience-components": "static-1.21943",
      "head-dlb": "static-1.4884",
      "hs-promise-utils": "static-1.5468",
      "hs-test-utils": "static-1.7883",
      "hubspot-dlb": "static-2.1806",
      "HubStyleTokens": "static-2.11316",
      "I18n": "static-7.1598",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.2890",
      "jasmine-runner": "static-1.6343",
      "quartz": "static-1.6831",
      "react-dlb": "static-1.74",
      "react-select-plus": "static-1.65",
      "react-transition-group": "static-2.62",
      "redux-thunk": "static-2.43",
      "sanitize": "static-1.4347",
      "StyleGuideUI": "static-3.485",
      "transmute": "static-2.85",
      "urlinator": "static-1.4405",
      "usage-tracker": "static-1.7209",
      "usage-tracker-core": "static-1.7059",
      "usage-tracker-public": "static-1.7020",
      "viral-links-lib": "static-1.6913",
      "visitor-ui-component-library": "static-1.6006",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4682",
      "conversations-prop-types": "static-1.7326",
      "conversations-visitor-message-history": "static-1.20680",
      "cssUtils": "static-1.764",
      "enviro": "static-4.416",
      "flux-actions": "static-1.323",
      "foundations-components": "static-1.7662",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.6092",
      "hubspot-url-utils": "static-1.3957",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9436",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.377",
      "raven": "static-3.5768",
      "react": "static-7.182",
      "react-aria": "static-1.63",
      "react-dom": "static-7.85",
      "react-redux": "static-7.67",
      "react-rhumb": "static-1.16525",
      "react-utils": "static-2.5242",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.8018",
      "signup-constants": "static-1.18568",
      "styled-components": "static-2.85",
      "usage-tracker-multi": "static-1.5623",
      "visitor-ui-component-library-icons": "static-1.5817",
      "hs-promise-rejection-tracking": "static-1.5433",
      "raven-hubspot": "static-1.6075",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3301",
      "moment": "static-3.26",
      "apollo-stack-hubspot": "static-3.83",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.79",
      "quartz-config": "static-1.609",
      "quartz-core": "static-1.6050",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4713",
      "foundations-theming": "static-1.4283",
      "UIComponents": "static-3.8263",
      "customer-data-email": "static-1.17802",
      "cv-backend-services": "static-1.1530",
      "immutable-less": "static-1.4526",
      "conversations-skeleton-state": "static-1.7121",
      "crm-events-viz-core": "static-1.32711",
      "customer-data-objects": "static-1.7527",
      "icons": "static-2.637",
      "react-input-autosize": "static-2.17",
      "rpc-client-utils": "static-1.4517",
      "ui-images": "static-2.1124",
      "HeadJS": "static-2.732",
      "framer-motion": "static-1.69",
      "hs-test-utils-bend-plugin": "static-1.2994",
      "msw": "static-1.39",
      "testing-library": "static-1.149",
      "i18n-data": "static-1.218",
      "moment-timezone": "static-5.80",
      "jasmine": "static-4.4198",
      "signup-ui-url-generator": "static-2.7909",
      "HubStyle": "static-2.11624",
      "quartz-i18n": "static-1.506",
      "sassPrefix": "static-1.153",
      "bend-plugin-foundations-components": "static-1.3931",
      "floating-ui": "static-1.53",
      "foundations-theming-specialty": "static-1.1999",
      "hs-story-utils": "static-1.9300",
      "react-virtualized": "static-2.96",
      "tanstack-table": "static-1.52",
      "trellis-assets": "static-1.1424",
      "ui-fonts": "static-1.578",
      "csstype": "static-1.50",
      "quick-fetch": "static-1.3807",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.5626",
      "bender-build-tools": "static-1.3025",
      "dispatcher": "static-1.133",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.816",
      "hubspotter-http": "static-1.4547",
      "mobile-manifest-mixins": "static-1.506",
      "module-federation": "static-1.20",
      "quartz-auth": "static-1.506",
      "quartz-head": "static-1.496",
      "quartz-routing": "static-1.261",
      "quartz-test": "static-1.506",
      "quartz-tracking": "static-1.210",
      "usage-tracker-container": "static-1.7199",
      "bend-plugin-foundations-theming": "static-1.2766",
      "foundations-theming-base": "static-1.3268",
      "stylex": "static-1.29",
      "apollo-dlb": "static-3.80",
      "apollo-link-hub-http": "static-2.4524",
      "customer-data-ui-utilities": "static-1.9697",
      "FileManagerCore": "static-1.38659",
      "FileManagerLib": "static-1.38800",
      "hubspot-apollo-client": "static-1.4752",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.522",
      "timezone-utils": "static-2.5117",
      "ui-gdpr-components": "static-1.10221",
      "ts-schema": "static-1.3974",
      "ai-components-ui-library": "static-1.8575",
      "avatar-components": "static-1.2366",
      "content-assistance-lib": "static-1.7553",
      "crm-component-utils": "static-1.38673",
      "crm-display-components": "static-1.24423",
      "crm-fe-perf": "static-1.22776",
      "crm-links": "static-1.6143",
      "crm-message-bus": "static-1.42592",
      "crm-search-service-types": "static-1.1024",
      "crm-source-interpretation-lib": "static-1.5204",
      "customer-data-communicator": "static-1.45128",
      "customer-data-filters-ui": "static-1.39176",
      "customer-data-objects-ui-components": "static-1.12887",
      "customer-data-properties": "static-1.51034",
      "customer-data-rte": "static-1.32633",
      "draft-plugins": "static-2.21442",
      "file-manager-components": "static-1.23160",
      "framework-data-schema-resolvers": "static-1.6747",
      "frontend-preferences-client": "static-1.7797",
      "hubspot-prosemirror": "static-1.17827",
      "object-comments-thread-lib": "static-1.10279",
      "reference-resolvers-lite": "static-1.7959",
      "ui-addon-upgrades": "static-9.17776",
      "universal-associations-select": "static-1.10872",
      "universal-record-utils-lib": "static-1.456",
      "inbound-db-properties-service-client": "static-1.3740",
      "property-translator": "static-1.5281",
      "chirp-fetch": "static-1.1755",
      "hub-http-shared-msw-handlers": "static-1.9655",
      "hubspotter-http-shared-msw-handlers": "static-1.9653",
      "react-router-dom": "static-5.26",
      "usage-tracker-session-replay": "static-1.4895",
      "react-dnd-compat": "static-1.4492",
      "audio-components": "static-1.5716",
      "cropperjs": "static-1.10",
      "FileManagerImages": "static-1.36311",
      "foundations-components-legacy": "static-1.687",
      "immerable": "static-1.4026",
      "ui-universal-auth": "static-1.8794",
      "video-components": "static-1.12809",
      "video-data-lib": "static-1.34464",
      "video-embed": "static-1.35298",
      "hubspot-apollo-cache": "static-1.211",
      "chatspot-core": "static-1.20652",
      "ContentUtils": "static-1.67855",
      "copilot-toolkit": "static-1.10739",
      "superstore": "static-1.4641",
      "ui-addon-video-player": "static-1.8568",
      "ui-coaching-tips": "static-1.28145",
      "card-properties-lib": "static-1.43737",
      "commerce-subscription-lib": "static-1.36674",
      "crm-actions": "static-1.6183",
      "crm-cards-sdk": "static-1.43149",
      "customer-data-properties-shared-msw-handlers": "static-1.8982",
      "customer-data-property-utils": "static-1.7954",
      "customer-data-tracking": "static-1.6756",
      "hs-entities": "static-1.564",
      "inbound-db-meta-service-client": "static-1.3484",
      "pulse": "static-1.404",
      "framework-data-table": "static-2.11597",
      "location-customization-utils-lib": "static-1.8794",
      "calling-error-reporting": "static-1.31179",
      "calling-internal-common": "static-1.31173",
      "calling-usage-tracker": "static-1.6414",
      "crm_data": "static-4.91496",
      "customer-data-content": "static-1.27020",
      "draft-content-plugins": "static-1.27901",
      "draft-convert": "static-2.70",
      "draft-extend": "static-3.72",
      "draft-js": "static-5.75",
      "draft-signature-plugin": "static-1.23703",
      "EmailSignatureEditor": "static-1.24056",
      "hubspot-prosemirror-plugins": "static-1.17819",
      "integration-settings-components": "static-1.15039",
      "integrations-lib": "static-1.15657",
      "integrations-tracking-lib": "static-1.5464",
      "native-integrations-shared-strings": "static-1.7659",
      "nav-meta": "static-1.29174",
      "onboarding-scopes": "static-1.6336",
      "outreach-assistant-email-generation": "static-1.5936",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.37543",
      "react-colorpicker": "static-2.10083",
      "reference-resolvers": "static-1.8039",
      "rich-text-lib": "static-1.19604",
      "sales-email-signature-service-client": "static-1.3716",
      "sequences-lib": "static-1.7815",
      "ui-addon-i18n": "static-1.11019",
      "ui-addon-iframeable": "static-1.8921",
      "ui-business-units-lib": "static-1.8909",
      "ui-shepherd-react": "static-3.10019",
      "user-context": "static-1.4973",
      "whatsapp-sending-lib": "static-1.5106",
      "customer-data-filters-ui-msw-helpers": "static-1.21611",
      "customer-data-reference-ui-components": "static-1.13023",
      "FormUrlGenerator": "static-2.4594",
      "framework-builder-read-service-client": "static-1.3902",
      "framework-data-schema-quick-fetch": "static-1.6652",
      "multi-account-reference-resolvers": "static-1.852",
      "onboarding-tours": "static-1.16370",
      "reporting-datasets-permissions-lib": "static-1.13274",
      "SharedI18nStrings": "static-1.181",
      "ui-addon-teams": "static-1.21353",
      "calling-global-api": "static-1.63962",
      "calling-lifecycle-internal": "static-1.65344",
      "calling-lifecycle-messages": "static-1.57638",
      "commerce-products-lib": "static-1.9055",
      "conditional-properties-service-client": "static-1.3692",
      "external-options-client-types": "static-1.4053",
      "google-libphonenumber": "static-1.35",
      "hs-resources": "static-1.6",
      "inbounddb-objects-service-types": "static-1.4117",
      "meetings-icalendar-utils-lib": "static-1.504",
      "multi-currency-client-types": "static-1.3584",
      "object-builder-ui-client": "static-1.48262",
      "pipeline-validation-client-types": "static-1.3858",
      "property-value-citations": "static-1.1648",
      "smart-property-lib": "static-1.6249",
      "tiered-pricing": "static-1.951",
      "ui-addon-form-validation": "static-1.10865",
      "video-components-external": "static-1.10806",
      "batch-promise": "static-1.1425",
      "crm-pipelines-api-client-types": "static-1.4036",
      "persist-promise": "static-1.3582",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.24939",
      "knowledge-content-types": "static-1.8431",
      "payment-link-components": "static-1.23136",
      "ui-addon-emoji-picker": "static-1.9760",
      "call-summary": "static-1.38653",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.9801",
      "laboratory-lib": "static-3.7033",
      "merchandise-lib": "static-1.261",
      "purchase-motions-components": "static-1.5614",
      "crm-object-search-query-utilities": "static-1.9249",
      "amplitude-session-replay-browser": "static-1.57",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "unified-auth-core-lib": "static-1.589",
      "content-icons-ui": "static-1.2188",
      "social-insights-client-types": "static-1.21623",
      "outpost": "static-1.4071",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4681",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5467",
      "magpie-types": "static-1.4927",
      "simple-logging-lib": "static-1.2923",
      "growth-onboarding-feedback-components": "static-1.6454",
      "customer-data-sidebar": "static-2.45621",
      "enrichment-properties-lib": "static-1.15367",
      "commerce-billing-lib": "static-1.18697",
      "commerce-shared-components-lib": "static-1.18158",
      "commerce-tools-ui-lib": "static-1.9995",
      "directed-graph": "static-1.811",
      "event-emitter": "static-1.820",
      "fast-json-patch": "static-1.60",
      "customer-data-associations": "static-1.7195",
      "deal-intel-decorators": "static-1.1512",
      "reporting-data": "static-1.66845",
      "tanstack-virtual": "static-1.27",
      "ui-addon-draggable": "static-3.4641",
      "crm-record-cards-service-types": "static-1.3511",
      "self-service-api": "static-1.10115",
      "crm_universal": "static-1.21777",
      "SalesContentIndexUI": "static-3.9024",
      "content-embed-lib": "static-1.7213",
      "data-model-builder-lib": "static-1.11876",
      "remote-ui": "static-1.62",
      "ui-components-test-utils": "static-1.5454",
      "ui-extensions-remote-renderer": "static-1.16582",
      "universal-page-editor-lib": "static-1.2874",
      "integrations-error-boundary-lib": "static-1.13072",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10247",
      "rxjs": "static-5.10",
      "unified-auth": "static-1.308",
      "messaging-types-lib": "static-1.45573",
      "data-token-picker": "static-1.16175",
      "sequences-client-types-lib": "static-1.7672",
      "foundations-components-test-utils": "static-1.5145",
      "navigation-messaging": "static-1.6864",
      "getting-started-shared-tasks": "static-1.18091",
      "getting-started-shared-tasks-store": "static-1.17209",
      "onboarding-tours-utils": "static-1.436",
      "messaging-usage-based-billing-components-lib": "static-1.698",
      "whatsapp-management-lib": "static-1.8265",
      "growth-data-modal": "static-1.5233",
      "growth-onboarding-confetti": "static-1.2945",
      "growth-onboarding-next-action-utils": "static-1.1498",
      "navigation-components": "static-1.17537",
      "onboarding-tours-client": "static-1.4584",
      "ui-shepherd-tracker": "static-1.7400",
      "shared-worker-versioning": "static-1.10912",
      "voice-sms-access-library": "static-1.466",
      "commerce-permissions": "static-1.637",
      "products-iframe-lib": "static-1.7541",
      "products-ui-components-shared-msw-handlers": "static-1.10037",
      "breeze-intelligence-kit": "static-1.5426",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9738",
      "fsm": "static-1.3604",
      "policy-lib": "static-1.6652",
      "react-tinymce": "static-1.54837",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.53963",
      "tinymce-plugins": "static-1.57077",
      "tinymce-themes": "static-1.55933",
      "content-media-composition-data-lib": "static-1.11754",
      "content-media-compositions": "static-2.15761",
      "idb-keyval": "static-1.41",
      "media-bridge-lib": "static-1.18698",
      "ui-addon-opt": "static-4.8257",
      "commerce-tours-lib": "static-1.5844",
      "growth-onboarding-reliability": "static-1.4959",
      "sales-checkout-service-client": "static-1.3541",
      "ai-addon-copilot-preview": "static-1.7787",
      "calling-cross-tab-library": "static-1.19145",
      "calling-lifecycle-usage-tracker": "static-1.8333",
      "wootric-nps": "static-1.6856",
      "growth-monetization-service-types": "static-1.4371",
      "nav-client-types": "static-1.2230",
      "purchase-motions-api": "static-1.5617",
      "trials-service-types": "static-1.3772",
      "reactive-lib": "static-1.597",
      "card-payment-highlight-lib": "static-1.36725",
      "card-subscription-highlight-lib": "static-1.39097",
      "commerce-contract-lib": "static-1.11475",
      "invoices-highlight-card-lib": "static-1.54262",
      "orders-highlight-card-lib": "static-1.21068",
      "products-highlight-card-lib": "static-1.17339",
      "quotes-highlight-card-lib": "static-1.71453",
      "usage-based-billing-components-lib": "static-1.8225",
      "utility-belt": "static-1.2413",
      "payments-enrollment-embed-lib": "static-1.22222",
      "growth-onboarding-empty-states": "static-1.5477",
      "InboxConnectUtils": "static-4.14426",
      "payments-post-enroll-local-storage-lib": "static-1.4986",
      "qrcode-generator": "static-1.66",
      "deal-intel-utils": "static-1.1516",
      "storybook-react": "static-1.30",
      "reporting-client-types": "static-1.2414",
      "react-flip-move": "static-1.67",
      "FireAlarmUi": "static-1.4403",
      "sales-templates-service-types-lib": "static-1.4061",
      "ui-asset-management-lib": "static-1.10821",
      "association-settings-lib": "static-1.9881",
      "collaboration-sidebar": "static-1.57342",
      "conditional-property-settings-modal": "static-1.12130",
      "data-model-commons-lib": "static-1.12165",
      "feedback-loader": "static-1.29025",
      "nudge-client-utils": "static-1.2301",
      "final-form": "static-1.67",
      "html-to-image": "static-1.51",
      "object-definition-builder-lib": "static-1.6949",
      "property-management-iframe": "static-1.12668",
      "property-usages-lib": "static-1.5278",
      "reactflow": "static-1.61",
      "simple-data-table": "static-1.2387",
      "used-in-list-lib": "static-1.6804",
      "visual-association": "static-1.5732",
      "highcharts": "static-8.101",
      "reporting-visualizations": "static-1.58921",
      "ui-extensibility-client-types": "static-1.3814",
      "automation-platform-service-types": "static-1.2544",
      "ContentData": "static-1.67930",
      "email-portal-health-service-types": "static-1.849",
      "marketing-email-service-types": "static-1.1822",
      "messaging-shared-utils-lib": "static-1.147",
      "messaging-user-info-utils-lib": "static-1.317",
      "content-whatsapp-service-types": "static-1.300",
      "marketing-platform-lib": "static-1.6719",
      "short-messages-app-service-client": "static-1.3867",
      "ui-tool-access": "static-1.10018",
      "growth-onboarding-next-action-components": "static-1.1526",
      "user-context-client": "static-1.4485",
      "nest": "static-1.94",
      "calling-orchestration-schema": "static-1.35243",
      "sales-views-client-types": "static-1.4136",
      "trellis-story-utils": "static-1.4393",
      "hub-http-contrib": "static-1.2916",
      "interframe": "static-3.4635",
      "tinymce-data": "static-1.40048",
      "ui-addon-sales-email": "static-1.5086",
      "codemirror": "static-5.92",
      "layout-dnd-components": "static-1.12190",
      "layout-dnd-utils": "static-1.11165",
      "react-codemirror": "static-1.10498",
      "ui-brand-identity-lib": "static-1.14429",
      "NamespacedHubStyle": "static-2.8963",
      "js-cookie": "static-1.18",
      "ai-rendering-library": "static-1.9573",
      "ai-settings-ui-library": "static-1.7670",
      "copilot-plugins": "static-1.10712",
      "eligibility-engine-service-types": "static-1.3053",
      "products-ui-components": "static-1.39574",
      "quotes-ui-lib": "static-1.80174",
      "zustand": "static-1.51",
      "accounting-integrations-ui-components": "static-1.6853",
      "invoices-ui-lib": "static-1.54278",
      "commerce-products-api": "static-1.2077",
      "invoices-iframe-lib": "static-1.56336",
      "quotes-modal-lib": "static-1.102131",
      "platform-infra-nav-components": "static-1.7561",
      "reporting-ui-components": "static-2.64116",
      "subscription-experience-data-types": "static-1.14683",
      "marketplace-ui-apps-core": "static-1.17707",
      "stripe-embedded-components": "static-1.7274",
      "ui-addon-react-router-dom": "static-1.9418",
      "association-translator": "static-1.3058",
      "crm-settings-header-lib": "static-1.8199",
      "settings-ui-nav": "static-2.10059",
      "chatspot-widget-iframe": "static-1.20644",
      "collaboration-sidebar-common": "static-1.2139",
      "crm-properties-common-lib": "static-1.5746",
      "ui-addon-draggable-compat": "static-2.4127",
      "nudge-custom-function-registry": "static-1.2058",
      "nudge-renderer-utils": "static-1.2377",
      "whisper-core-api": "static-1.6197",
      "property-management-common": "static-1.4956",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.14923",
      "advanced-menus-lib": "static-1.11889",
      "ExportDialog": "static-6.10262",
      "ui-memberships-settings-lib": "static-1.33653",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.9490",
      "browser-eslint": "static-2.57",
      "embedded-academy-lib": "static-1.13831",
      "highlight.js": "static-1.76",
      "reporting-action-components": "static-1.40860",
      "reporting-snowflake": "static-1.55463",
      "commerce-tax-lib": "static-1.391",
      "property-description-translator": "static-1.3727",
      "commerce-analytics-service-client": "static-1.3529",
      "totals-ui-components": "static-1.23190",
      "reporting-plugins": "static-1.10074",
      "reporting-reports": "static-1.66523",
      "edison-service-client-types": "static-1.265",
      "developer-experience-shared-components": "static-1.10374",
      "marketplace-ui-client-types": "static-1.16581",
      "marketplace-ui-common": "static-1.19174",
      "ui-addon-integrations-directory-panel": "static-2.7864",
      "stripe-connect-js": "static-1.66",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.14922",
      "simple-menus-lib": "static-1.16439",
      "academy-common-lib": "static-1.13291",
      "dashboard-lib": "static-1.80941",
      "share-with-third-party-component-lib": "static-1.8566",
      "commerce-totals-service-types": "static-1.3710",
      "campaign-roi-lib": "static-1.8509",
      "apps-service-types": "static-1.3750",
      "oauth-service-types": "static-1.4120",
      "react-window": "static-1.13",
      "academy-service-client": "static-1.3553",
      "redux-actions": "static-3.7"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.28580",
      "ably": "/ably/static-2.2",
      "data-fetching-client": "/data-fetching-client/static-1.9549",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4584",
      "atom": "/atom/static-1.4943",
      "conversations-async-data": "/conversations-async-data/static-2.7537",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8750",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15838",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12618",
      "conversations-message-history": "/conversations-message-history/static-1.12251",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10372",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.21943",
      "head-dlb": "/head-dlb/static-1.4884",
      "hs-promise-utils": "/hs-promise-utils/static-1.5468",
      "hs-test-utils": "/hs-test-utils/static-1.7883",
      "hubspot-dlb": "/hubspot-dlb/static-2.1806",
      "HubStyleTokens": "/HubStyleTokens/static-2.11316",
      "I18n": "/I18n/static-7.1598",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.2890",
      "jasmine-runner": "/jasmine-runner/static-1.6343",
      "quartz": "/quartz/static-1.6831",
      "react-dlb": "/react-dlb/static-1.74",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-transition-group": "/react-transition-group/static-2.62",
      "redux-thunk": "/redux-thunk/static-2.43",
      "sanitize": "/sanitize/static-1.4347",
      "StyleGuideUI": "/StyleGuideUI/static-3.485",
      "transmute": "/transmute/static-2.85",
      "urlinator": "/urlinator/static-1.4405",
      "usage-tracker": "/usage-tracker/static-1.7209",
      "usage-tracker-core": "/usage-tracker-core/static-1.7059",
      "usage-tracker-public": "/usage-tracker-public/static-1.7020",
      "viral-links-lib": "/viral-links-lib/static-1.6913",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6006",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4682",
      "conversations-prop-types": "/conversations-prop-types/static-1.7326",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.20680",
      "cssUtils": "/cssUtils/static-1.764",
      "enviro": "/enviro/static-4.416",
      "flux-actions": "/flux-actions/static-1.323",
      "foundations-components": "/foundations-components/static-1.7662",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.6092",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9436",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.377",
      "raven": "/raven/static-3.5768",
      "react": "/react/static-7.182",
      "react-aria": "/react-aria/static-1.63",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.67",
      "react-rhumb": "/react-rhumb/static-1.16525",
      "react-utils": "/react-utils/static-2.5242",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.8018",
      "signup-constants": "/signup-constants/static-1.18568",
      "styled-components": "/styled-components/static-2.85",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5623",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5817",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
      "raven-hubspot": "/raven-hubspot/static-1.6075",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3301",
      "moment": "/moment/static-3.26",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.83",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.79",
      "quartz-config": "/quartz-config/static-1.609",
      "quartz-core": "/quartz-core/static-1.6050",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4713",
      "foundations-theming": "/foundations-theming/static-1.4283",
      "UIComponents": "/UIComponents/static-3.8263",
      "customer-data-email": "/customer-data-email/static-1.17802",
      "cv-backend-services": "/cv-backend-services/static-1.1530",
      "immutable-less": "/immutable-less/static-1.4526",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7121",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.32711",
      "customer-data-objects": "/customer-data-objects/static-1.7527",
      "icons": "/icons/static-2.637",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "rpc-client-utils": "/rpc-client-utils/static-1.4517",
      "ui-images": "/ui-images/static-2.1124",
      "HeadJS": "/HeadJS/static-2.732",
      "framer-motion": "/framer-motion/static-1.69",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2994",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.149",
      "i18n-data": "/i18n-data/static-1.218",
      "moment-timezone": "/moment-timezone/static-5.80",
      "jasmine": "/jasmine/static-4.4198",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7909",
      "HubStyle": "/HubStyle/static-2.11624",
      "quartz-i18n": "/quartz-i18n/static-1.506",
      "sassPrefix": "/sassPrefix/static-1.153",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3931",
      "floating-ui": "/floating-ui/static-1.53",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1999",
      "hs-story-utils": "/hs-story-utils/static-1.9300",
      "react-virtualized": "/react-virtualized/static-2.96",
      "tanstack-table": "/tanstack-table/static-1.52",
      "trellis-assets": "/trellis-assets/static-1.1424",
      "ui-fonts": "/ui-fonts/static-1.578",
      "csstype": "/csstype/static-1.50",
      "quick-fetch": "/quick-fetch/static-1.3807",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5626",
      "bender-build-tools": "/bender-build-tools/static-1.3025",
      "dispatcher": "/dispatcher/static-1.133",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.816",
      "hubspotter-http": "/hubspotter-http/static-1.4547",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.506",
      "module-federation": "/module-federation/static-1.20",
      "quartz-auth": "/quartz-auth/static-1.506",
      "quartz-head": "/quartz-head/static-1.496",
      "quartz-routing": "/quartz-routing/static-1.261",
      "quartz-test": "/quartz-test/static-1.506",
      "quartz-tracking": "/quartz-tracking/static-1.210",
      "usage-tracker-container": "/usage-tracker-container/static-1.7199",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2766",
      "foundations-theming-base": "/foundations-theming-base/static-1.3268",
      "stylex": "/stylex/static-1.29",
      "apollo-dlb": "/apollo-dlb/static-3.80",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4524",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9697",
      "FileManagerCore": "/FileManagerCore/static-1.38659",
      "FileManagerLib": "/FileManagerLib/static-1.38800",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4752",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.522",
      "timezone-utils": "/timezone-utils/static-2.5117",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10221",
      "ts-schema": "/ts-schema/static-1.3974",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8575",
      "avatar-components": "/avatar-components/static-1.2366",
      "content-assistance-lib": "/content-assistance-lib/static-1.7553",
      "crm-component-utils": "/crm-component-utils/static-1.38673",
      "crm-display-components": "/crm-display-components/static-1.24423",
      "crm-fe-perf": "/crm-fe-perf/static-1.22776",
      "crm-links": "/crm-links/static-1.6143",
      "crm-message-bus": "/crm-message-bus/static-1.42592",
      "crm-search-service-types": "/crm-search-service-types/static-1.1024",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5204",
      "customer-data-communicator": "/customer-data-communicator/static-1.45128",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39176",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12887",
      "customer-data-properties": "/customer-data-properties/static-1.51034",
      "customer-data-rte": "/customer-data-rte/static-1.32633",
      "draft-plugins": "/draft-plugins/static-2.21442",
      "file-manager-components": "/file-manager-components/static-1.23160",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6747",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7797",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17827",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.10279",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7959",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17776",
      "universal-associations-select": "/universal-associations-select/static-1.10872",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.456",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3740",
      "property-translator": "/property-translator/static-1.5281",
      "chirp-fetch": "/chirp-fetch/static-1.1755",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9655",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9653",
      "react-router-dom": "/react-router-dom/static-5.26",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4895",
      "react-dnd-compat": "/react-dnd-compat/static-1.4492",
      "audio-components": "/audio-components/static-1.5716",
      "cropperjs": "/cropperjs/static-1.10",
      "FileManagerImages": "/FileManagerImages/static-1.36311",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.687",
      "immerable": "/immerable/static-1.4026",
      "ui-universal-auth": "/ui-universal-auth/static-1.8794",
      "video-components": "/video-components/static-1.12809",
      "video-data-lib": "/video-data-lib/static-1.34464",
      "video-embed": "/video-embed/static-1.35298",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.211",
      "chatspot-core": "/chatspot-core/static-1.20652",
      "ContentUtils": "/ContentUtils/static-1.67855",
      "copilot-toolkit": "/copilot-toolkit/static-1.10739",
      "superstore": "/superstore/static-1.4641",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8568",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.28145",
      "card-properties-lib": "/card-properties-lib/static-1.43737",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36674",
      "crm-actions": "/crm-actions/static-1.6183",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.43149",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8982",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7954",
      "customer-data-tracking": "/customer-data-tracking/static-1.6756",
      "hs-entities": "/hs-entities/static-1.564",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3484",
      "pulse": "/pulse/static-1.404",
      "framework-data-table": "/framework-data-table/static-2.11597",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8794",
      "calling-error-reporting": "/calling-error-reporting/static-1.31179",
      "calling-internal-common": "/calling-internal-common/static-1.31173",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6414",
      "crm_data": "/crm_data/static-4.91496",
      "customer-data-content": "/customer-data-content/static-1.27020",
      "draft-content-plugins": "/draft-content-plugins/static-1.27901",
      "draft-convert": "/draft-convert/static-2.70",
      "draft-extend": "/draft-extend/static-3.72",
      "draft-js": "/draft-js/static-5.75",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.23703",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24056",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17819",
      "integration-settings-components": "/integration-settings-components/static-1.15039",
      "integrations-lib": "/integrations-lib/static-1.15657",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5464",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7659",
      "nav-meta": "/nav-meta/static-1.29174",
      "onboarding-scopes": "/onboarding-scopes/static-1.6336",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.5936",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.37543",
      "react-colorpicker": "/react-colorpicker/static-2.10083",
      "reference-resolvers": "/reference-resolvers/static-1.8039",
      "rich-text-lib": "/rich-text-lib/static-1.19604",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3716",
      "sequences-lib": "/sequences-lib/static-1.7815",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11019",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8921",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8909",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10019",
      "user-context": "/user-context/static-1.4973",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.5106",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21611",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13023",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4594",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3902",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6652",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.852",
      "onboarding-tours": "/onboarding-tours/static-1.16370",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13274",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
      "ui-addon-teams": "/ui-addon-teams/static-1.21353",
      "calling-global-api": "/calling-global-api/static-1.63962",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65344",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57638",
      "commerce-products-lib": "/commerce-products-lib/static-1.9055",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3692",
      "external-options-client-types": "/external-options-client-types/static-1.4053",
      "google-libphonenumber": "/google-libphonenumber/static-1.35",
      "hs-resources": "/hs-resources/static-1.6",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4117",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.504",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3584",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.48262",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3858",
      "property-value-citations": "/property-value-citations/static-1.1648",
      "smart-property-lib": "/smart-property-lib/static-1.6249",
      "tiered-pricing": "/tiered-pricing/static-1.951",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10865",
      "video-components-external": "/video-components-external/static-1.10806",
      "batch-promise": "/batch-promise/static-1.1425",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4036",
      "persist-promise": "/persist-promise/static-1.3582",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.24939",
      "knowledge-content-types": "/knowledge-content-types/static-1.8431",
      "payment-link-components": "/payment-link-components/static-1.23136",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9760",
      "call-summary": "/call-summary/static-1.38653",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9801",
      "laboratory-lib": "/laboratory-lib/static-3.7033",
      "merchandise-lib": "/merchandise-lib/static-1.261",
      "purchase-motions-components": "/purchase-motions-components/static-1.5614",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9249",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.57",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.589",
      "content-icons-ui": "/content-icons-ui/static-1.2188",
      "social-insights-client-types": "/social-insights-client-types/static-1.21623",
      "outpost": "/outpost/static-1.4071",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4681",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5467",
      "magpie-types": "/magpie-types/static-1.4927",
      "simple-logging-lib": "/simple-logging-lib/static-1.2923",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6454",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.45621",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15367",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.18697",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18158",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9995",
      "directed-graph": "/directed-graph/static-1.811",
      "event-emitter": "/event-emitter/static-1.820",
      "fast-json-patch": "/fast-json-patch/static-1.60",
      "customer-data-associations": "/customer-data-associations/static-1.7195",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.1512",
      "reporting-data": "/reporting-data/static-1.66845",
      "tanstack-virtual": "/tanstack-virtual/static-1.27",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4641",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3511",
      "self-service-api": "/self-service-api/static-1.10115",
      "crm_universal": "/crm_universal/static-1.21777",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9024",
      "content-embed-lib": "/content-embed-lib/static-1.7213",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.11876",
      "remote-ui": "/remote-ui/static-1.62",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5454",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.16582",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2874",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13072",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10247",
      "rxjs": "/rxjs/static-5.10",
      "unified-auth": "/unified-auth/static-1.308",
      "messaging-types-lib": "/messaging-types-lib/static-1.45573",
      "data-token-picker": "/data-token-picker/static-1.16175",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7672",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5145",
      "navigation-messaging": "/navigation-messaging/static-1.6864",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18091",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17209",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.436",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.698",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.8265",
      "growth-data-modal": "/growth-data-modal/static-1.5233",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2945",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1498",
      "navigation-components": "/navigation-components/static-1.17537",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4584",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7400",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10912",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.466",
      "commerce-permissions": "/commerce-permissions/static-1.637",
      "products-iframe-lib": "/products-iframe-lib/static-1.7541",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10037",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5426",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9738",
      "fsm": "/fsm/static-1.3604",
      "policy-lib": "/policy-lib/static-1.6652",
      "react-tinymce": "/react-tinymce/static-1.54837",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.53963",
      "tinymce-plugins": "/tinymce-plugins/static-1.57077",
      "tinymce-themes": "/tinymce-themes/static-1.55933",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11754",
      "content-media-compositions": "/content-media-compositions/static-2.15761",
      "idb-keyval": "/idb-keyval/static-1.41",
      "media-bridge-lib": "/media-bridge-lib/static-1.18698",
      "ui-addon-opt": "/ui-addon-opt/static-4.8257",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5844",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4959",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3541",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.7787",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19145",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.8333",
      "wootric-nps": "/wootric-nps/static-1.6856",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4371",
      "nav-client-types": "/nav-client-types/static-1.2230",
      "purchase-motions-api": "/purchase-motions-api/static-1.5617",
      "trials-service-types": "/trials-service-types/static-1.3772",
      "reactive-lib": "/reactive-lib/static-1.597",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36725",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39097",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.11475",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54262",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21068",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17339",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71453",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8225",
      "utility-belt": "/utility-belt/static-1.2413",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22222",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5477",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.14426",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4986",
      "qrcode-generator": "/qrcode-generator/static-1.66",
      "deal-intel-utils": "/deal-intel-utils/static-1.1516",
      "storybook-react": "/storybook-react/static-1.30",
      "reporting-client-types": "/reporting-client-types/static-1.2414",
      "react-flip-move": "/react-flip-move/static-1.67",
      "FireAlarmUi": "/FireAlarmUi/static-1.4403",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4061",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10821",
      "association-settings-lib": "/association-settings-lib/static-1.9881",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.57342",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.12130",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.12165",
      "feedback-loader": "/feedback-loader/static-1.29025",
      "nudge-client-utils": "/nudge-client-utils/static-1.2301",
      "final-form": "/final-form/static-1.67",
      "html-to-image": "/html-to-image/static-1.51",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.6949",
      "property-management-iframe": "/property-management-iframe/static-1.12668",
      "property-usages-lib": "/property-usages-lib/static-1.5278",
      "reactflow": "/reactflow/static-1.61",
      "simple-data-table": "/simple-data-table/static-1.2387",
      "used-in-list-lib": "/used-in-list-lib/static-1.6804",
      "visual-association": "/visual-association/static-1.5732",
      "highcharts": "/highcharts/static-8.101",
      "reporting-visualizations": "/reporting-visualizations/static-1.58921",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3814",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2544",
      "ContentData": "/ContentData/static-1.67930",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.849",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1822",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.147",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.317",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.300",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6719",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3867",
      "ui-tool-access": "/ui-tool-access/static-1.10018",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1526",
      "user-context-client": "/user-context-client/static-1.4485",
      "nest": "/nest/static-1.94",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35243",
      "sales-views-client-types": "/sales-views-client-types/static-1.4136",
      "trellis-story-utils": "/trellis-story-utils/static-1.4393",
      "hub-http-contrib": "/hub-http-contrib/static-1.2916",
      "interframe": "/interframe/static-3.4635",
      "tinymce-data": "/tinymce-data/static-1.40048",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5086",
      "codemirror": "/codemirror/static-5.92",
      "layout-dnd-components": "/layout-dnd-components/static-1.12190",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.11165",
      "react-codemirror": "/react-codemirror/static-1.10498",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14429",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8963",
      "js-cookie": "/js-cookie/static-1.18",
      "ai-rendering-library": "/ai-rendering-library/static-1.9573",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7670",
      "copilot-plugins": "/copilot-plugins/static-1.10712",
      "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3053",
      "products-ui-components": "/products-ui-components/static-1.39574",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.80174",
      "zustand": "/zustand/static-1.51",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6853",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.54278",
      "commerce-products-api": "/commerce-products-api/static-1.2077",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56336",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.102131",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7561",
      "reporting-ui-components": "/reporting-ui-components/static-2.64116",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14683",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17707",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.7274",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9418",
      "association-translator": "/association-translator/static-1.3058",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.8199",
      "settings-ui-nav": "/settings-ui-nav/static-2.10059",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20644",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2139",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5746",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4127",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2058",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2377",
      "whisper-core-api": "/whisper-core-api/static-1.6197",
      "property-management-common": "/property-management-common/static-1.4956",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.14923",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11889",
      "ExportDialog": "/ExportDialog/static-6.10262",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33653",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.9490",
      "browser-eslint": "/browser-eslint/static-2.57",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.13831",
      "highlight.js": "/highlight.js/static-1.76",
      "reporting-action-components": "/reporting-action-components/static-1.40860",
      "reporting-snowflake": "/reporting-snowflake/static-1.55463",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.391",
      "property-description-translator": "/property-description-translator/static-1.3727",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3529",
      "totals-ui-components": "/totals-ui-components/static-1.23190",
      "reporting-plugins": "/reporting-plugins/static-1.10074",
      "reporting-reports": "/reporting-reports/static-1.66523",
      "edison-service-client-types": "/edison-service-client-types/static-1.265",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10374",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16581",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.19174",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7864",
      "stripe-connect-js": "/stripe-connect-js/static-1.66",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.14922",
      "simple-menus-lib": "/simple-menus-lib/static-1.16439",
      "academy-common-lib": "/academy-common-lib/static-1.13291",
      "dashboard-lib": "/dashboard-lib/static-1.80941",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8566",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3710",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.8509",
      "apps-service-types": "/apps-service-types/static-1.3750",
      "oauth-service-types": "/oauth-service-types/static-1.4120",
      "react-window": "/react-window/static-1.13",
      "academy-service-client": "/academy-service-client/static-1.3553",
      "redux-actions": "/redux-actions/static-3.7"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.28580",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};